module.exports = "/images/deleted_watcher.png?d13bc822db30b0f0128a05e3cf1b2d48";